module.exports = __webpack_public_path__ + "static/jscclogo-4ed9369105e39fc035e4c78f0f83dd15.png";